export default [
  {
    type: 'html',
    family: 'html',
    label: 'Free form',
    variants: [
      {
        name: 'html',
        label: 'Free form',
        imageUrl: window.constants.imageUrl + 'blocks1/text_paragraph.jpg'
      }
    ]
  },
  {
    type: 'text',
    family: 'text',
    label: 'Text',
    variants: [
      {
        name: 'paragraph',
        label: 'Paragraph',
        imageUrl: window.constants.imageUrl + 'blocks1/text_paragraph.jpg'
      },
      {
        name: 'headingParagraph',
        label: 'Paragraph with heading',
        imageUrl: window.constants.imageUrl + 'blocks1/text_paragraph_heading.jpg'
      },
      {
        name: 'subheadingParagraph',
        label: 'Paragraph with Subheading',
        imageUrl: window.constants.imageUrl + 'blocks1/text_paragraph_subheading.jpg'
      },
      {
        name: 'subheading',
        label: 'Subheading',
        imageUrl: window.constants.imageUrl + 'blocks1/text_subheading.png'
      },
      {
        name: 'heading',
        label: 'Heading',
        imageUrl: window.constants.imageUrl + 'blocks1/text_heading.png'
      },
      {
        name: 'twoColumn',
        label: 'Two column',
        imageUrl: window.constants.imageUrl + 'blocks1/text_two_column.jpg'
      }
    ]
  },
  {
    type: 'quote',
    family: 'quote',
    label: 'Quote',
    variants: [
      {
        name: 'quoteA',
        label: 'Quote A',
        imageUrl: window.constants.imageUrl + 'blocks1/quote_a.png'
      },
      {
        name: 'quoteB',
        label: 'Quote B',
        imageUrl: window.constants.imageUrl + 'blocks1/quote_b.png'
      },
      {
        name: 'quoteC',
        label: 'Quote C',
        imageUrl: window.constants.imageUrl + 'blocks1/quote_c.png'
      },
      {
        name: 'quoteD',
        label: 'Quote D',
        imageUrl: window.constants.imageUrl + 'blocks1/quote_d.png'
      },
      {
        name: 'quoteBackground',
        label: 'Quote Background',
        imageUrl: window.constants.imageUrl + 'blocks1/quote_e.png'
      }
    ]
  },
  {
    type: 'impact',
    family: 'impact',
    label: 'Statement',
    variants: [
      {
        name: 'impactA',
        label: 'Statement A',
        imageUrl: window.constants.imageUrl + 'blocks1/statement_a.png'
      },
      {
        name: 'impactB',
        label: 'Statement B',
        imageUrl: window.constants.imageUrl + 'blocks1/statement_b.png'
      },
      {
        name: 'impactC',
        label: 'Statement C',
        imageUrl: window.constants.imageUrl + 'blocks1/statement_c.png'
      },
      {
        name: 'impactD',
        label: 'Statement D',
        imageUrl: window.constants.imageUrl + 'blocks1/statement_d.png'
      }
    ]
  },
  {
    type: 'list',
    family: 'list',
    label: 'List',
    variants: [
      {
        name: 'numbered',
        label: 'Numbered',
        imageUrl: window.constants.imageUrl + 'blocks1/list_numbered.jpg'
      },
      {
        name: 'bulleted',
        label: 'Bulleted',
        imageUrl: window.constants.imageUrl + 'blocks1/list_bulleted.jpg'
      }
    ]
  },
  {
    type: 'image',
    family: 'image',
    label: 'Image',
    variants: [
      {
        name: 'hero',
        label: 'Image centered',
        imageUrl: window.constants.imageUrl + 'blocks1/image_centered.jpg'
      },
      {
        name: 'textAsideRight',
        label: 'Image on right & text',
        imageUrl: window.constants.imageUrl + 'blocks1/image_image_right_and_text.jpg'
      },
      {
        name: 'textAsideLeft',
        label: 'Image on left & text',
        imageUrl: window.constants.imageUrl + 'blocks1/image_image_left_and_text.jpg'
      },
      {
        name: 'textOverlay',
        label: 'Text on image',
        imageUrl: window.constants.imageUrl + 'blocks1/statement_e.png'
      },
      {
        name: 'full',
        label: 'Image full width',
        imageUrl: window.constants.imageUrl + 'blocks1/image_full_width.jpg'
      }
    ]
  },
  {
    type: 'multimedia',
    family: 'multimedia',
    label: 'Multimedia',
    variants: [
      {
        name: 'audio',
        label: 'Audio',
        imageUrl: window.constants.imageUrl + 'blocks1/multimedia_audio.jpg'
      },
      {
        name: 'video',
        label: 'Video',
        imageUrl: window.constants.imageUrl + 'blocks1/multimedia_video.jpg'
      },
      {
        name: 'embed',
        label: 'Embed',
        imageUrl: window.constants.imageUrl + 'blocks1/multimedia_embed.jpg'
      },
      {
        name: 'attachment',
        label: 'Attachment',
        imageUrl: window.constants.imageUrl + 'blocks1/multimedia_attachment.jpg'
      }
    ]
  },
  {
    type: 'interactive',
    family: 'interactive',
    label: 'Interactive',
    variants: [
      {
        name: 'flashcardStack',
        label: 'Flashcard Stack',
        imageUrl: window.constants.imageUrl + 'blocks1/Stack.jpg'
      },
      {
        name: 'flashcardGrid',
        label: 'Flashcard Grid',
        imageUrl: window.constants.imageUrl + 'blocks1/Grid.jpg'
      },
      {
        name: 'accordion',
        label: 'Accordion',
        imageUrl: window.constants.imageUrl + 'blocks1/accordian.jpg'
      },
      {
        name: 'tabs',
        label: 'Tabs',
        imageUrl: window.constants.imageUrl + 'blocks1/tabforcreator.jpg'
      }
    ]
  }
];
